import { useState, useEffect, useRef, useCallback } from 'react';
import { ResponsiveCalendar, ResponsiveTimeRange } from "@nivo/calendar";
import { ResponsiveBar } from '@nivo/bar'

import { ccColorDarkTeal, ccColorLightTeal, ccColorOrange, ccColorSecondaryBronze, ccColorSecondaryPurple, ccColorTeal } from "../components/helpersStyles";
import dayjs from "dayjs";
import axios from 'axios';
import { CcLoader } from './generalComponents';


const DayToolTip = ({ day, value, fetchData, cache }) => {
  const [data, setData] = useState(() => cache.current[day]);

  useEffect(() => {
    if (cache.current[day]) {
      setData(cache.current[day]);
    } else {
      fetchData(day).then((json) => setData(json));
    }
  }, [day, fetchData, cache]);


  return <div className="w-[360px] rounded-md shadow-md bg-white text-ccColorDarkTeal text-sm px-3 py-1 border border-gray-200">
    <div className='flex flex-row items-center'>
      <div className='font-semibold text-lg'>{day.format('dddd D MMM YYYY')}</div>
      <div className='flex grow'></div>
      <div className='text-slate-600'>{value} {value > 1 ? "emails" : "email"}</div>
    </div>
    {data === undefined && <CcLoader size={32} />}

    {data && data.map(d =>     <div className='flex flex-row mt-4 gap-x-2'>
              <img className='w-[100px] h-auto' src={`${process.env.REACT_APP_LION_API_URL}/${d.imgUrl}`} alt={d.subject} />
              <div className='flex flex-col'>
                <div className='text-gray-900 font-poppins font-semibold'>{d.subject}</div>
                <div className='mt-1 text-gray-500'>{d.preheader}</div>
              </div>
            </div>)
    }
  </div>
}

const CcHeatmapCalendar = (props) => {
  // Example data
  const dataInit = [
    { day: "2025-01-01", value: 3 },
  ];

    const [data, setData] = useState([])
    const [tooltipInfo, setTooltipInfo] = useState(null); // { day, value, x, y }

    let endDate = dayjs();
    let startDate = endDate.subtract(1, "year").add(1, "day");
    const dayOfWeek = startDate.day(); // 0 = Sunday, 1 = Monday, ...
    if (dayOfWeek !== 0) {
        startDate = startDate.subtract(dayOfWeek, "day");
    }
    if (props.startDate && props.endDate) {
      startDate = dayjs(props.startDate)
      endDate = dayjs(props.endDate)
    }


    let normalScale = undefined
    const specialDays = new Set([
      "2025-01-01",
      "2025-07-04",
      "2025-12-25",
    ])    


    useEffect(() => {
        getHeatmap();
    }, [])
    const getHeatmap = async () => {

        try {  
        let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Reports/heatmap?startDate=${startDate.format("YYYY-MM-DD")}&endDate=${endDate.format("YYYY-MM-DD")}`;
        if (props.brandId) url += `&brandId=${props.brandId}`

        const response = await axios.get(url);
        const data = response.data;
        //remapping props
        const rData = data.map(d => {return {day: d.date, value: d.numEmails}})

        const allValues = data.map(d => d.numEmails)
        const min = Math.min(...allValues)
        const max = Math.max(...allValues)

        //console.log(rData)


        setData(rData)


        } catch (error) {
        console.log(error);
        }
    }


  const cache = useRef({});
  const inFlight = useRef({});

  const fetchData = useCallback(async (day) => {
    if (cache.current[day]) return cache.current[day];
    if (inFlight.current[day]) return inFlight.current[day];
    
    let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/EmailsForDay?day=${day.format("YYYY-MM-DD")}`;
    if (props.brandId) url += `&brandId=${props.brandId}`

    inFlight.current[day] =  axios
      .get(url)
      .then((res) => {
        cache.current[day] = res.data; // save to cache
        delete inFlight.current[day]; // release lock
        return res.data;
      })
      .catch((err) => {
        console.error(err);
        delete inFlight.current[day];
        throw err;
      });
    
  }, [cache]);    

 const handleMouseEnter = useCallback(
    (cell, event) => {
      const { day, value } = cell;
      const { clientX, clientY } = event; // mouse position
      setTooltipInfo({ day: dayjs(day), value, x: clientX, y: clientY });
      fetchData(dayjs(day)); // trigger fetch (tooltip will render loading first)
    },
    [fetchData]
  );

  const handleMouseLeave = useCallback(() => {
    setTooltipInfo(null);
  }, []);  
    
  return (
    <div style={{ height: 300, position: "relative" }}>
        <ResponsiveTimeRange
                data={data}
                from={startDate.format("YYYY-MM-DD")}
                to={endDate.format("YYYY-MM-DD")}
                emptyColor="#eeeeee"
                colors={[ccColorLightTeal, ccColorTeal, ccColorDarkTeal]}
                margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
                dayBorderWidth={2}
                dayBorderColor="#ffffff"
                legends={[
                {
                    anchor: "bottom-right",
                    direction: "row",
                    translateY: 36,
                    itemCount: 4,
                    itemWidth: 42,
                    itemHeight: 36,
                    itemsSpacing: 14,
                    itemDirection: "right-to-left",
                },
                ]}
                theme={{
                            labels: {
                            text: {
                                fontSize: 11,
                                fill: ccColorTeal,
                                textTransform: "none",
                                fontFamily: "poppins",
                            },
                            },
                        }}
                weekdayTicks={[0, 1, 2, 3, 4, 5, 6]}   // 👈 show all weekdays
                weekdayLegend={(day) => 
                                    ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][day]
                                }
                                
                tooltip={() => null} // disable built-in tooltip
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              
                /*
                tooltip={({ day, value }) => (
                <DayToolTip day={dayjs(day)} value={value} cache={cache}
                    fetchData={fetchData} />
                )}
              */
        />

{tooltipInfo && (<div           style={{
            position: "absolute",
            top: 10, // offset to avoid mouse pointer
            left: tooltipInfo.x >= 700 ? tooltipInfo.x -460 : tooltipInfo.x -120,
            pointerEvents: "none",
            zIndex: 999,
          }}
>
        <DayToolTip
          day={tooltipInfo.day}
          value={tooltipInfo.value}
          fetchData={fetchData}
          cache={cache}
        />
        </div >
      )}

    </div>
  );
};

function generateTickValues(numTicks, maxValue) {
  if (numTicks < 2) return [0, maxValue]

  // Find a "nice" step size
  const roughStep = maxValue / (numTicks - 1)
  const step = Math.ceil(roughStep) // ensure integer step, rounded up

  // Compute new max to evenly fit steps
  const niceMax = step * (numTicks - 1)

  // Generate ticks
  const ticks = []
  for (let i = 0; i < numTicks; i++) {
    ticks.push(i * step)
  }

  return ticks
}


const CcDaysOfWeekReport = (props) => {

    const [data, setData] = useState([])
    const [ticks, setTicks] = useState([0,1])

    let endDate = dayjs();
    let startDate = endDate.subtract(1, "year").add(1, "day");
    const dayOfWeek = startDate.day(); // 0 = Sunday, 1 = Monday, ...
    if (dayOfWeek !== 0) {
        startDate = startDate.subtract(dayOfWeek, "day");
    }
    if (props.startDate && props.endDate) {
      startDate = dayjs(props.startDate)
      endDate = dayjs(props.endDate)
    }



    useEffect(() => {
       getDaysOfWeekData();
    }, [])
    const getDaysOfWeekData = async () => {

      try {  
        let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Reports/emailsByDayOfWeek?startDate=${startDate.format("YYYY-MM-DD")}&endDate=${endDate.format("YYYY-MM-DD")}`;
        if (props.brandId) url += `&brandId=${props.brandId}`

        const response = await axios.get(url);
        const data = response.data;
        //remapping props
        const rData = data.map(d => {return {label: d.dayOfWeek, value: d.numEmails}})

        const maxValue = Math.max(...data.map(d => d.numEmails))
        const newTicks = generateTickValues(6, maxValue)

        //console.log(newTicks)

        setTicks(newTicks)
        setData(rData)


        } catch (error) {
        console.log(error);
      }
    }


    

  return (
    <div style={{ height: 400 }}>
      <ResponsiveBar
        data={data}
        keys={["value"]}
        indexBy="label"
        margin={{ top: 0, right: 20, bottom: 50, left: 80 }}
        padding={0.3}
        layout="horizontal"
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={ccColorSecondaryBronze}
        borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "",
          legendPosition: "middle",
          legendOffset: 40,
          tickValues: ticks
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "",
          legendPosition: "middle",
          legendOffset: -50
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        //labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        labelTextColor="#fff"
        animate={true}
        motionStiffness={90}
        motionDamping={15}
        theme={{
                labels: {
                  text: {
                    fontSize: 16,
                    fontWeight: 600,
                    fontFamily: "poppins",
                  }
                },
                axis: {
                      ticks: {
                        text: {
                          fontSize: 11,
                          fontFamily: "poppins",
                          fill: ccColorTeal
                        }
                      },
                    }                
      }}
      />
    </div>
  )
  
};

const CcTimeOfDayReport = (props) => {

    const [data, setData] = useState([])
    const [ticks, setTicks] = useState([0,1])

    let endDate = dayjs();
    let startDate = endDate.subtract(1, "year").add(1, "day");
    const dayOfWeek = startDate.day(); // 0 = Sunday, 1 = Monday, ...
    if (dayOfWeek !== 0) {
        startDate = startDate.subtract(dayOfWeek, "day");
    }
    if (props.startDate && props.endDate) {
      startDate = dayjs(props.startDate)
      endDate = dayjs(props.endDate)
    }



    useEffect(() => {
       getTimeOfDayData();
    }, [])
    const getTimeOfDayData = async () => {

      try {  
        let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Reports/emailsByTimeOfDay?startDate=${startDate.format("YYYY-MM-DD")}&endDate=${endDate.format("YYYY-MM-DD")}`;
        if (props.brandId) url += `&brandId=${props.brandId}`

        const response = await axios.get(url);
        const data = response.data;
        //remapping props
        const rData = data.map(d => {return {label: d.hour, value: d.numEmails}})

        const maxValue = Math.max(...data.map(d => d.numEmails))
        const newTicks = generateTickValues(6, maxValue)

        //console.log(newTicks)

        setTicks(newTicks)
        setData(rData)


        } catch (error) {
        console.log(error);
      }
    }


    

  return (
    <div style={{ height: 400 }}>
      <ResponsiveBar
        data={data}
        keys={["value"]}
        indexBy="label"
        margin={{ top: 0, right: 20, bottom: 50, left: 80 }}
        padding={0.3}
        //layout="horizontal"
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={ccColorSecondaryPurple}
        borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "",
          legendPosition: "middle",
          legendOffset: 40,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "",
          legendPosition: "middle",
          legendOffset: -50,
          tickValues: ticks
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        //labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        labelTextColor="#fff"
        animate={true}
        motionStiffness={90}
        motionDamping={15}
        theme={{
                labels: {
                  text: {
                    fontSize: 16,
                    fontWeight: 600,
                    fontFamily: "poppins",
                  }
                },
                axis: {
                      ticks: {
                        text: {
                          fontSize: 11,
                          fontFamily: "poppins",
                          fill: ccColorTeal
                        }
                      },
                    }                
      }}
      />
    </div>
  )
  
};



export {CcHeatmapCalendar, CcDaysOfWeekReport, CcTimeOfDayReport};
